import * as React from "react";

const CustomChevronDown: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <polygon points="18 15 12 9 6 15"></polygon>
        </svg>
    );
};

export default React.memo(CustomChevronDown);
